import React, { Component } from 'react';
import chingoDentalLogo from '@/assets/img/chingo-dental-logo.png';

class PrintOrthoCompletion extends Component {
    render() {
        return (
            <div className="print-page print-ortho-completion">
                <div className="ortho-completion-header">
                    <div className="ortho-completion-logo-wrap">
                        <img
                            className="ortho-completion-logo"
                            src={chingoDentalLogo}
                            alt="Chingo Dental"
                        />
                    </div>

                    <div className="ortho-completion-title-wrap">
                        <div className="ortho-completion-title">
                            CAM KẾT ĐỒNG Ý KẾT THÚC ĐIỀU TRỊ CHỈNH NHA MẮC CÀI
                        </div>
                        <div className="ortho-completion-subtitle">
                            (Dành cho bệnh nhân kết thúc điều trị chỉnh nha mắc cài)
                        </div>
                    </div>
                </div>

                <div className="ortho-completion-content">
                    <p>
                        Tôi tên là: .................................................................................................CMND số........................................
                    </p>

                    <p>
                        Là&nbsp;&nbsp;&nbsp;&nbsp;☐ bệnh nhân&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;☐ thân nhân đại diện của bệnh nhân ..............................................................................
                    </p>

                    <p>
                        Hiện đang điều trị chỉnh nha mắc cài tại chi nhánh&nbsp;&nbsp;
                        ..........................................................., Nha Khoa Chingo
                        <br />
                        do bác sĩ ................................................................... phụ trách.
                    </p>

                    <p className="ortho-completion-italic">
                        Sau quá trình điều trị, tôi và bác sĩ điều trị thống nhất đã đạt được mục tiêu điều trị về khớp răng và thẩm mỹ mô mềm và đồng thuận quyết định tháo mắc cài kết thúc điều trị, chuyển sang giai đoạn duy trì. Tôi hoàn toàn đồng ý với các chi tiết sau:
                    </p>

                    <ul className="ortho-completion-bullets ortho-completion-main-bullets">
                        <li>
                            Tôi/ thân nhân của tôi đã được bác sĩ giải thích đầy đủ cách thức chăm sóc răng sau chỉnh nha và có trách nhiệm tuân thủ chỉ định đeo hàm duy trì để duy trì kết quả chỉnh nha đang có.
                        </li>
                        <li>
                            Tôi hiểu rằng để kết thúc điều trị, bác sĩ sẽ tiến hành tháo mắc cài và các khí cụ niềng răng khác (nếu có). Nếu trước khi tiến hành tháo mắc cài tôi/ thân nhân của tôi đổi ý thì ý muốn của tôi sẽ được tôn trọng. Tôi/ thân nhân của tôi sẽ không được phép đổi ý khi thủ thuật đang tiến hành.
                        </li>
                        <li>
                            Tôi/thân nhân của tôi có trách nhiệm quay lại nhận hàm duy trì theo đúng hẹn mà bác sĩ chỉ định. Nếu không tuân thủ mà hàm duy trì không vừa (đối với hàm duy trì nội địa) HOẶC hết thời hạn bảo hành của hãng (đối với hàm duy trì Vivera) thì tôi sẽ chịu hoàn toàn trách nhiệm.
                        </li>
                        <li>
                            Hàm duy trì nội địa được phòng khám bảo hành trong vòng 01 tháng kể từ ngày nhận hàm trong các trường hợp gãy, vỡ. Hàm duy trì Vivera được hãng bảo hành với sự hỗ trợ của phòng khám theo chính sách chung của hãng sản xuất. Để được bảo hành, bệnh nhân cần mang hàm duy trì này tới phòng khám.
                        </li>
                    </ul>

                    <p className="ortho-completion-italic ortho-completion-confirm-title">
                        Tôi ký bản cam kết ngày nghĩa là:
                    </p>

                    <ul className="ortho-completion-bullets ortho-completion-confirm-bullets">
                        <li>Tôi đã đọc và hiểu nội dung của bản cam kết.</li>
                        <li>Tất cả thắc mắc của tôi đã được cung cấp thông tin trả lời thỏa đáng.</li>
                        <li>Tôi cam kết sẽ không thắc mắc hay khiếu nại gì về sau.</li>
                    </ul>

                    <div className="ortho-completion-signature-line">
                        <strong>
                            Bệnh nhân/thân nhân (kí và ghi rõ họ tên): ..............................................................
                        </strong>
                        <strong>Ngày: ..../..../.......</strong>
                    </div>

                    <div className="ortho-completion-separator" />

                    <div className="ortho-completion-staff-title">
                        Phần dành cho nhân viên phòng khám:
                    </div>

                    <div className="ortho-completion-patient-line">
                        Tên bệnh nhân: ...............................................................................SĐT........................................................
                    </div>

                    <table className="ortho-completion-table">
                        <tbody>
                            <tr>
                                <td className="ortho-completion-documents-cell">
                                    <div className="ortho-completion-table-heading">
                                        Đính kèm các tài liệu:
                                    </div>
                                    <div>1) .............................................................</div>
                                    <div>2) .............................................................</div>
                                    <div>3) .............................................................</div>
                                </td>
                                <td className="ortho-completion-recipients-cell">
                                    <div className="ortho-completion-table-heading">Nơi nhận:</div>
                                    <div>☐ Lưu HSBA&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;☐ Labo</div>
                                    <div>☐ Bộ phận y tá&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;☐ Bộ phận sales</div>
                                    <div>☐ Trả bệnh nhân&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;☐ Văn phòng (Bộ phận):.....................</div>
                                    <div>☐ Khác: ................................................................................</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <style>
                    {`
                        @page {
                            size: A4 portrait;
                            margin: 0;
                        }

                        .print-ortho-completion,
                        .print-ortho-completion * {
                            box-sizing: border-box;
                        }

                        .print-ortho-completion {
                            width: 210mm;
                            height: 297mm;
                            overflow: hidden;
                            padding: 14.2mm 11.4mm 10mm;
                            background: #fff;
                            color: #000;
                            font-family: "Times New Roman", Times, serif;
                            font-size: 12pt;
                            font-weight: 400;
                            line-height: 1.15;
                        }

                        .ortho-completion-header {
                            display: grid;
                            grid-template-columns: 56.1mm 1fr;
                            align-items: start;
                            width: 100%;
                            margin-bottom: 11.4mm;
                        }

                        .ortho-completion-logo-wrap {
                            padding-left: 4.7mm;
                            padding-top: 0.1mm;
                        }

                        .ortho-completion-logo {
                            display: block;
                            width: 45.77mm;
                            height: 8.47mm;
                            object-fit: contain;
                        }

                        .ortho-completion-title-wrap {
                            text-align: center;
                            white-space: nowrap;
                        }

                        .ortho-completion-title {
                            font-size: 12pt;
                            line-height: 1.05;
                            font-weight: 700;
                        }

                        .ortho-completion-subtitle {
                            margin-top: 0.6mm;
                            font-size: 12pt;
                            line-height: 1.05;
                            font-style: italic;
                        }

                        .ortho-completion-content p {
                            margin: 0 0 4.3mm;
                        }

                        .ortho-completion-italic {
                            padding-right: 2mm;
                            font-style: italic;
                        }

                        .ortho-completion-bullets {
                            list-style: none;
                            width: calc(100% - 12.2mm);
                            margin: 0 0 0 4.8mm;
                            padding: 0;
                        }

                        .ortho-completion-bullets li {
                            position: relative;
                            margin: 0;
                            padding: 0;
                            text-indent: 5mm;
                            text-align: left;
                        }

                        .ortho-completion-bullets li::before {
                            content: "•";
                            position: absolute;
                            left: 0;
                            top: 0;
                            text-indent: 0;
                            font-family: "Times New Roman", Times, serif;
                            font-size: 12pt;
                        }

                        .ortho-completion-main-bullets {
                            margin-top: 6.9mm;
                            margin-bottom: 2.1mm;
                        }

                        .ortho-completion-main-bullets li {
                            margin-bottom: 0.2mm;
                            line-height: 1.30;
                        }

                        .ortho-completion-confirm-title {
                            margin-bottom: 4.2mm !important;
                        }

                        .ortho-completion-confirm-bullets {
                            margin-bottom: 4.5mm;
                        }

                        .ortho-completion-confirm-bullets li {
                            min-height: 5.4mm;
                        }

                        .ortho-completion-signature-line {
                            display: flex;
                            align-items: baseline;
                            justify-content: space-between;
                            width: calc(100% - 7.5mm);
                            margin-bottom: 8.6mm;
                            white-space: nowrap;
                        }

                        .ortho-completion-separator {
                            height: 0;
                            margin: 0 7.5mm 5.2mm 0;
                            border-top: 0.25mm solid #000;
                        }

                        .ortho-completion-staff-title {
                            margin-bottom: 5.2mm;
                            font-weight: 700;
                            font-style: italic;
                            text-decoration: underline;
                        }

                        .ortho-completion-patient-line {
                            margin-bottom: 4.5mm;
                            line-height: 1.15;
                        }

                        .ortho-completion-table {
                            width: calc(100% - 9.4mm);
                            margin-left: 3.2mm;
                            border-collapse: collapse;
                            table-layout: fixed;
                            font-family: "Times New Roman", Times, serif;
                            font-size: 12pt;
                            line-height: 1.04;
                        }

                        .ortho-completion-table td {
                            vertical-align: top;
                            border: 0.25mm solid #000;
                            padding: 0.8mm 1.7mm 0.7mm;
                        }

                        .ortho-completion-documents-cell {
                            width: 41%;
                        }

                        .ortho-completion-documents-cell > div {
                            white-space: nowrap;
                        }

                        .ortho-completion-recipients-cell {
                            width: 59%;
                            white-space: nowrap;
                        }

                        .ortho-completion-table-heading {
                            font-weight: 700;
                            font-style: italic;
                        }

                        @media print {
                            html,
                            body {
                                width: 210mm !important;
                                height: 297mm !important;
                                margin: 0 !important;
                                padding: 0 !important;
                                background: #fff !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }

                            .print-ortho-completion {
                                width: 210mm !important;
                                height: 297mm !important;
                                margin: 0 !important;
                                break-after: avoid-page;
                                page-break-after: avoid;
                            }
                        }
                    `}
                </style>
            </div>
        );
    }
}

export default PrintOrthoCompletion;
